import { useNavigate } from "react-router-dom";
import TableFilter from "./tableFilter";
import { useEffect } from "react";

function Sanstha() {
  const navigate = useNavigate();
  const sansthaId = localStorage.getItem("sansthaId");
 // console.log(sansthaId, "sansthaIdsansthaId")
  const permissionOfSanstha = localStorage.getItem("permissionOfSanstha");

    useEffect(() => {
    if (sansthaId || permissionOfSanstha) {
      navigate(`/sanstha/details/${sansthaId || permissionOfSanstha}`);
    }
  }, [sansthaId, navigate]);
  return (
    <>
      <div className="content-wrapper">
        <div
          className="content-heading d-flex
                          justify-content-between"
        >
          <div>Sanstha</div>
          <div>
            <button
              className="btn btn-labeled btn-success" 
              type="button"
              style={{ fontSize: "17px" }}
              onClick={() => navigate("/sanstha/new")}
            >
              <span className="btn-label">
                <em className="fas fa-plus"></em>
              </span>
              New Sanstha
            </button>
          </div>
        </div>
        <TableFilter />
      </div>
    </>
  );
}

export default Sanstha;
